(function ($, window, document) {

var slideUpTransition = function () {
  return this.each(function () {
    var $el = $(this);
    $el.css('max-height', '0');
    $el.css('opacity', '0');
    $el.addClass('height-transition-hidden');
  });
};

var slideDownTransition = function (del) {
  if (!del) {
    del = 1;
  }

  return this.each(function () {
    var $el = $(this);
    $el.removeClass('height-transition-hidden');

    // temporarily make visible to get the size
    var transitionValue = $el.css('transition');
    $el.css({'max-height': 'none', 'transition': 'none'});

    var height = $el.outerHeight();

    // reset to 0 then animate with small delay
    $el.css('max-height', '0');

    setTimeout(function () {
      $el.css({
        'max-height': height,
        'transition': transitionValue
      });
      $el.css('opacity', '1');
    }, del);
  });
};

var oldSlideDown = $.fn.slideDownTransition;
var oldSlideUp = $.fn.slideUpTransition;

$.fn.slideDownTransition = slideDownTransition;
$.fn.slideUpTransition = slideUpTransition;

$.fn.slideDownTransition.noConflict = function () {
  $.fn.slideDownTransition = oldSlideDown;
  return this;
};

$.fn.slideUpTransition.noConflict = function () {
  $.fn.slideUpTransition = oldSlideUp;
  return this;
};

function onDOMContentLoaded() {
  var $teaserlists = $('.teaser-list.limited');
  var limit = -1;
  $teaserlists.each(function (index, element) {
    var teaserLimitTxt = $(element).find('.clearteaserlimit p').text();
    $(element).data('teaserLimitTxt', teaserLimitTxt);

    limit = parseInt($(element).attr('data-limit'), 10);
    $(element).find('.teaser__box').each(function (idx, el) {
      if (idx >= limit) {
        $(el).addClass('height-transition height-transition-hidden');
      }
    });
  });

  $('.teaser-list').each(function (index, element) {
    $(element).find('a').each((function (key, link) {
      var href = $(link).attr('href') || '';
      if (href.slice(0, 2) === '/#') {
        href = href.replace('/#', window.location.pathname + '#');
        $(link).attr('href', href);
      }
    }));
  });

  $('.clearteaserlimit').on('click', function (e) {
    e.preventDefault();
    $.fn.reverse = [].reverse;
    var element = $(this).closest('.teaser-list');
    limit = parseInt(element.attr('data-limit'), 10);
    var teaserList = element.closest('.teaser-list');
    var limited = teaserList.hasClass('limited');

    if (limited) {
      teaserList.find('.clearteaserlimit p').addClass('expanded').html('');
      teaserList.removeClass('limited')
        .find('.teaser__box')
        .slice(limit).each(function (index) {
        $(this).slideDownTransition(1 + index * 100);
      });
    } else {
      teaserList.find('.clearteaserlimit p').removeClass('expanded').html(teaserList.data('teaserLimitTxt'));
      teaserList.addClass('limited')
        .find('.teaser__box')
        .slice(limit).reverse().each(function () {
        $(this).slideUpTransition();
      });
    }
  });
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})(jQuery, window, document);
